function maybeSendFacebookPixelEvent(event, dogId) {
    if (!dogId) {
        return;
    }

    // Helpers
    function getQueryParam(param) {
        try {
            if (typeof window === 'undefined' || !window.location || !window.location.search) return null;
            var query = window.location.search.substring(1);
            var params = query.split('&');
            for (var i = 0; i < params.length; i++) {
                var pair = params[i].split('=');
                if (decodeURIComponent(pair[0]) === param) {
                    return typeof pair[1] !== 'undefined' ? decodeURIComponent(pair[1]) : '';
                }
            }
            return null;
        } catch (_e) {
            return null;
        }
    }

    function getCookieSafe(name) {
        try {
            if (typeof window !== 'undefined' && typeof window.getCookie === 'function') {
                return window.getCookie(name);
            }
            var nameEQ = name + '=';
            var ca = (document.cookie || '').split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        } catch (_e) {
            return null;
        }
    }

    function setCookieSafe(name, value, days) {
        try {
            if (typeof window !== 'undefined' && typeof window.setCookie === 'function') {
                window.setCookie(name, value, days);
                return;
            }
            var expires = '';
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = '; expires=' + date.toUTCString();
            }
            document.cookie = name + '=' + (value || '') + expires + '; path=/';
        } catch (_e) {
            // no-op
        }
    }

    function ensureFacebookCookies() {
        var existingFbc = getCookieSafe('_fbc');
        var existingFbp = getCookieSafe('_fbp');
        var now = Date.now();
        var fbclid = getQueryParam('fbclid');

        // _fbc should be set only if there is an fbclid available
        if (!existingFbc && fbclid) {
            var fbcValue = 'fb.1.' + String(now) + '.' + fbclid;
            setCookieSafe('_fbc', fbcValue, 90);
        }

        // _fbp is a client identifier; generate if missing
        if (!existingFbp) {
            var randomId = Math.floor(Math.random() * 1e10);
            var fbpValue = 'fb.1.' + String(now) + '.' + String(randomId);
            setCookieSafe('_fbp', fbpValue, 90);
        }
    }

    // Only send Lead on thank-you pages
    var isLeadEvent = typeof event === 'string' && event.toLowerCase() === 'lead';
    if (isLeadEvent) {
        var href =
            typeof window !== 'undefined' &&
                window.location &&
                typeof window.location.href === 'string'
                ? window.location.href
                : '';
        if (href.indexOf('thank-you') === -1) {
            return;
        }
    }

    var maxAttempts = 8;
    var initialDelayMs = 250;
    var maxDelayMs = 4000;
    var attempt = 0;

    function trySend(delayMs) {
        if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
            try {
                // Ensure cookies exist before sending
                ensureFacebookCookies();
                window.fbq('track', event, {}, { eventID: dogId });
            } catch (err) {
                if (typeof console !== 'undefined' && typeof console.warn === 'function') {
                    console.warn('Failed to send Facebook Pixel event:', event, err);
                }
            }
            return;
        }

        attempt += 1;
        if (attempt >= maxAttempts) {
            if (typeof console !== 'undefined' && typeof console.warn === 'function') {
                console.warn('Facebook Pixel not available; event cancelled:', event);
            }
            return;
        }

        var nextDelay = Math.min(delayMs * 2, maxDelayMs);
        setTimeout(function () {
            trySend(nextDelay);
        }, delayMs);
    }

    trySend(initialDelayMs);
}
